import { FAVICON_URL, SITE_URL } from "@/mocks/site";

interface ArticleJsonLdOptions {
  lang: string;
  slug: string;
  title: string;
  description: string;
  image?: string;
  dateModified?: string;
}

function organizationSchema() {
  return {
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: "usfanslink.lol",
    url: `${SITE_URL}/`,
    logo: {
      "@type": "ImageObject",
      url: FAVICON_URL,
    },
  };
}

export function websiteJsonLd(lang: string) {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
        url: `${SITE_URL}/${lang}/`,
        name: "USFans Spreadsheet",
        inLanguage: lang,
        description:
          "Find products, compare finds and shop smarter with the USFans Spreadsheet.",
      },
      organizationSchema(),
    ],
  };
}

export function articleJsonLd({
  lang,
  slug,
  title,
  description,
  image,
  dateModified,
}: ArticleJsonLdOptions) {
  const base = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    datePublished: "2026-08-21",
    dateModified: dateModified || "2026-08-21",
    author: { "@type": "Organization", name: "usfanslink.lol" },
    publisher: organizationSchema(),
    mainEntityOfPage: `${SITE_URL}/${lang}/article/${slug}`,
  };
  return image ? { ...base, image } : base;
}

export default function JsonLd({ data }: { data: object }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}